import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_BASE } from '../../../../../api';
import ImportacionMasivaModal from './ImportacionMasivaModal';
import AlertDialog from '../../../../Lms/Components/Shared/AlertDialog';
import '../../../Styles/ImportacionMasiva.css';
import sigmaDelete from '../../../../Pages/img/Borrar.png';

/**
 * Componentes de pasos para el Wizard de Importación
 */

// Paso 1: Instrucciones
const StepInstructions = ({ setCanNext }) => {
    useEffect(() => {
        setCanNext(true);
    }, [setCanNext]);

    return (
        <div className="import-modal-placeholder">
            <h3 style={{ fontSize: '1.8rem', marginBottom: '0.5rem' }}>¡Bienvenido al Asistente de Importación Masiva!</h3>
            <p style={{ fontSize: '1.1rem', color: '#475569', maxWidth: '600px', margin: '0 auto 2rem' }}>
                Sigue estos pasos clave para asegurar que tu <br /><strong>proceso de registro masivo</strong> sea exitoso:
            </p>

            <div style={{
                background: '#fff',
                borderRadius: '24px',
                border: '1px solid #e2e8f0',
                width: '100%',
                maxWidth: '680px',
                margin: '0 auto',
                textAlign: 'left',
                overflow: 'hidden',
                boxShadow: '0 10px 25px -5px rgba(0,0,0,0.05)'
            }}>
                {/* Instrucción 1 */}
                <div style={{
                    padding: '1.5rem',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '1.5rem',
                    borderBottom: '1px solid #f1f5f9'
                }}>
                    <div style={{ background: '#e0f2fe', color: '#0ea5e9', width: '48px', height: '48px', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <i className="fas fa-file-excel" style={{ fontSize: '1.2rem' }}></i>
                    </div>
                    <div>
                        <h4 style={{ margin: 0, color: '#1e293b', fontSize: '1.05rem', fontWeight: 700 }}>1. Usa el formato oficial</h4>
                        <p style={{ margin: '0.4rem 0 0', fontSize: '0.9rem', color: '#64748b', lineHeight: '1.5' }}>
                            En el paso siguiente podrás descargar la plantilla Excel. Es vital que la uses como base única para tu información.
                        </p>
                    </div>
                </div>

                {/* Instrucción 2 */}
                <div style={{
                    padding: '1.5rem',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '1.5rem',
                    borderBottom: '1px solid #f1f5f9'
                }}>
                    <div style={{ background: '#fef3c7', color: '#d97706', width: '48px', height: '48px', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <i className="fas fa-shield-alt" style={{ fontSize: '1.2rem' }}></i>
                    </div>
                    <div>
                        <h4 style={{ margin: 0, color: '#1e293b', fontSize: '1.05rem', fontWeight: 700 }}>2. Respeta la estructura del archivo</h4>
                        <p style={{ margin: '0.4rem 0 0', fontSize: '0.9rem', color: '#64748b', lineHeight: '1.5' }}>
                            <strong>No modifiques los nombres ni el orden</strong> de las columnas. El sistema depende de esta estructura para procesar los datos correctamente.
                        </p>
                    </div>
                </div>

                {/* Instrucción 3 */}
                <div style={{
                    padding: '1.5rem',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '1.5rem'
                }}>
                    <div style={{ background: '#dcfce7', color: '#16a34a', width: '48px', height: '48px', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <i className="fas fa-check-double" style={{ fontSize: '1.2rem' }}></i>
                    </div>
                    <div>
                        <h4 style={{ margin: 0, color: '#1e293b', fontSize: '1.05rem', fontWeight: 700 }}>3. Verifica los datos requeridos</h4>
                        <p style={{ margin: '0.4rem 0 0', fontSize: '0.9rem', color: '#64748b', lineHeight: '1.5' }}>
                            Completa la información asegurándote de no dejar campos obligatorios vacíos y que los correos tengan el formato adecuado.
                        </p>
                    </div>
                </div>
            </div>

            <p style={{ marginTop: '2.5rem', fontSize: '0.95rem', color: '#64748b' }}>
                ¿Todo listo? Pulsa el botón <strong>Siguiente</strong> para obtener tu plantilla.
            </p>
        </div>
    );
};

// Paso 2: Descarga de Plantilla
const StepDownload = ({ currentModule, setCanNext, triggerAlert }) => {
    useEffect(() => {
        setCanNext(true); // Permitir avanzar por defecto
    }, [setCanNext]);

    const isEmpleado = currentModule === 'empleados';
    const assetBase = API_BASE.replace('/api', '');
    const downloadUrl = isEmpleado
        ? `${assetBase}/PlantillasExcel/ImportacionMasivaEmpleados.xlsx`
        : '#';

    const handleDownload = () => {
        if (isEmpleado) {
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', 'ImportacionMasivaEmpleados.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            triggerAlert("La plantilla para este módulo aún no está disponible.", "info", "Aviso");
        }
    };

    return (
        <div className="import-modal-placeholder">
            <div style={{
                maxWidth: '650px',
                margin: '0 auto 2rem',
                textAlign: 'left'
            }}>
                <div style={{ margin: 0, fontSize: '1.1rem', color: '#334155', lineHeight: '1.7' }}>
                    {isEmpleado ? (
                        <>
                            <p style={{ margin: 0 }}>
                                Para procesar correctamente la información de tus colaboradores, es indispensable utilizar nuestro <strong>formato estandarizado</strong>. Este archivo contiene las columnas y validaciones necesarias para que el sistema reconozca cada dato automáticamente.
                            </p>
                            <br />
                            <div style={{ marginTop: '1rem' }}>
                                <i className="fas fa-info-circle" style={{ color: '#0ea5e9', marginRight: '8px' }}></i>
                                <strong style={{ fontSize: '1rem', color: '#1e293b' }}>Recomendaciones importantes:</strong>
                            </div>
                            <ul style={{ marginTop: '1rem', paddingLeft: '1.5rem', color: '#64748b', fontSize: '0.95rem' }}>
                                <li style={{ marginBottom: '0.7rem' }}>No agregues, elimines ni cambies de posición ninguna columna.</li>
                                <li style={{ marginBottom: '0.7rem' }}>Evita usar caracteres especiales o formatos extraños en las celdas.</li>
                                <li style={{ marginBottom: '0.7rem' }}>Asegúrate de que los correos electrónicos tengan un formato válido (ej: usuario@empresa.com).</li>
                                <li>Si tienes dudas sobre algún campo, consulta el manual de usuario o contacta a soporte corporativo.</li>
                            </ul>
                        </>
                    ) : (
                        <p style={{ margin: 0 }}>
                            Descarga el formato oficial diseñado para este módulo. Utilizar esta plantilla garantiza que la estructura de datos sea compatible con nuestro motor de importación, evitando errores de validación y asegurando que tu información se registre de forma segura.
                        </p>
                    )}
                </div>
            </div>

            <button
                className={`btn-action ${!isEmpleado ? 'disabled' : ''}`}
                style={{
                    padding: '0.6rem 1.8rem',
                    fontSize: '0.9rem',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.6rem',
                    cursor: 'pointer',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.06)'
                }}
                onClick={handleDownload}
                disabled={!isEmpleado}
            >
                <i className="fas fa-file-excel" style={{ fontSize: '1.1rem' }}></i>
                Descargar Plantilla (.xlsx)
            </button>
        </div>
    );
};

// Paso 3: Carga de Archivo
const StepUpload = ({ setCanNext, setIsProcessing, wizardData, setWizardData, triggerAlert }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const fileInputRef = useRef(null);

    // Sincronizar estados con el Modal principal inmediatamente
    useEffect(() => {
        // Al montar y en cada cambio, reportamos el estado
        setCanNext(uploadSuccess && !isUploading);
        setIsProcessing(isUploading);
    }, [uploadSuccess, isUploading, setCanNext, setIsProcessing]);

    // Aseguramos bloqueo al montar si no hay éxito previo
    useEffect(() => {
        if (!uploadSuccess) {
            setCanNext(false);
        }
    }, []);

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // Validar extensión
        if (!file.name.match(/\.(xlsx|xls)$/)) {
            triggerAlert("Por favor seleccione un archivo Excel (.xlsx o .xls)");
            return;
        }

        setSelectedFile(file);
        setUploadSuccess(false);
        setIsUploading(true);
        // setCanNext(false) se ejecutará vía el useEffect de sincronización

        console.log("Iniciando carga de archivo:", file.name); // LOG DEPURACIÓN

        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(`${API_BASE}/upload/documento`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (response.status === 200) {
                const result = response.data;
                console.log("Archivo subido temporalmente:", result.filePath); // LOG DE DEPURACIÓN
                setUploadSuccess(true);
                setWizardData(prev => ({ ...prev, filePath: result.filePath }));
            }
        } catch (error) {
            console.error("Error en la carga:", error);
            const msg = error.response?.data?.message || 'Hubo un problema de conexión al subir el archivo.';
            triggerAlert(msg);
            setSelectedFile(null);
        } finally {
            setIsUploading(false);
        }
    };

    const handleClear = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedFile(null);
        setUploadSuccess(false);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const triggerFileSelect = () => {
        if (!isUploading && fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <div className="import-modal-placeholder">
            <div style={{
                maxWidth: '650px',
                margin: '0 auto 1rem',
                textAlign: 'left'
            }}>
                <div style={{ margin: 0, fontSize: '1.1rem', color: '#334155', lineHeight: '1.7' }}>
                    <p style={{ margin: 0 }}>
                        Ahora que tienes tu archivo listo, el siguiente paso es cargarlo al sistema. Arrastra el documento <strong>Excel (.xlsx)</strong> directamente al área de abajo o haz clic para buscarlo en tu equipo.
                    </p>
                    <br />
                    <div style={{ marginBottom: '0.8rem' }}>
                        <i className="fas fa-magic" style={{ color: '#0ea5e9', marginRight: '8px' }}></i>
                        <strong style={{ fontSize: '1rem', color: '#1e293b' }}>Procesamiento inteligente:</strong>
                    </div>
                    <ul style={{ margin: 0, paddingLeft: '1.5rem', color: '#64748b', fontSize: '0.95rem' }}>
                        <li style={{ marginBottom: '0.5rem' }}>El sistema validará automáticamente que la estructura sea correcta.</li>
                        <li style={{ marginBottom: '0.5rem' }}>Se detectarán posibles duplicados o errores antes de la importación final.</li>
                        <li>Podrás revisar una vista previa detallada en el siguiente paso.</li>
                    </ul>
                </div>
            </div>

            <div style={{ marginTop: '0.5rem', width: '100%', maxWidth: '600px' }}>
                <div
                    className={`file-uploader${uploadSuccess ? ' file-uploader--filled' : ''}${isUploading ? ' file-uploader--uploading' : ''}`}
                    onClick={triggerFileSelect}
                    style={{ cursor: isUploading ? 'wait' : 'pointer' }}
                >
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                        disabled={isUploading}
                    />

                    {uploadSuccess && (
                        <div className="file-uploader__badge">
                            <span>✓ Cargado</span>
                            <button
                                onClick={handleClear}
                                style={{ marginLeft: '8px', background: 'transparent', border: 'none', color: 'white', cursor: 'pointer', fontWeight: 'bold', fontSize: '1rem' }}
                            >×</button>
                        </div>
                    )}

                    {isUploading && (
                        <div className="file-uploader__badge" style={{ backgroundColor: '#3b82f6' }}>
                            <i className="fas fa-spinner fa-spin"></i>
                            <span>Subiendo...</span>
                        </div>
                    )}

                    <label className="file-uploader__label" style={{ pointerEvents: 'none' }}>
                        <span className="file-uploader__icon">
                            <i className={`fas ${uploadSuccess ? 'fa-file-excel' : (isUploading ? 'fa-sync fa-spin' : 'fa-file-excel')}`}
                                style={{ fontSize: '2.5rem', color: uploadSuccess ? '#10b981' : (isUploading ? '#3b82f6' : '#cbd5e1') }}></i>
                        </span>
                        <span className="file-uploader__text">
                            {selectedFile ? selectedFile.name : 'Haga clic para seleccionar o suelte aquí'}
                        </span>
                        {!selectedFile && <span className="file-uploader__hint">Solo archivos .xlsx o .xls</span>}
                    </label>
                </div>
            </div>

            {uploadSuccess && !isUploading && (
                <p style={{ marginTop: '1.5rem', color: '#059669', fontSize: '0.9rem', fontWeight: '500' }}>
                    <i className="fas fa-check-circle" style={{ marginRight: '6px' }}></i>
                    Archivo verificado. Pulsa <b>Siguiente</b> para ver la vista previa.
                </p>
            )}
        </div>
    );
};

// Paso 4: Vista Previa
const StepPreview = ({ currentModule, setCanNext, wizardData, setIsProcessing, setWizardData, onStepChange, triggerAlert }) => {
    const [previewData, setPreviewData] = useState({ headers: [], rows: [] });
    const [excludedRows, setExcludedRows] = useState(new Set());
    const [loading, setLoading] = useState(false);
    const [selectedErrors, setSelectedErrors] = useState(null); // Para el mini-modal de errores

    const { headers, rows } = previewData;

    // Sincronizar estadísticas con el wizardData para el paso final
    useEffect(() => {
        if (rows.length > 0) {
            const totalRows = rows.length;
            const duplicatesCount = rows.filter(r =>
                !r.isValid && r.errors.some(e =>
                    e.toLowerCase().includes('ya existe') ||
                    e.toLowerCase().includes('ya está en uso')
                )
            ).length;

            const finalErrorsCount = rows.filter(r => !r.isValid).length;

            // Cargados = Validos que NO fueron excluidos por el usuario
            const loadedCount = rows.filter((r, i) => r.isValid && !excludedRows.has(i)).length;

            setWizardData(prev => ({
                ...prev,
                summary: {
                    total: totalRows,
                    loaded: loadedCount,
                    errors: finalErrorsCount - duplicatesCount, // Errores que no son duplicados
                    duplicates: duplicatesCount
                }
            }));
        }
    }, [rows, excludedRows, setWizardData]);

    useEffect(() => {
        if (wizardData.filePath) {
            fetchPreviewData();
        } else {
            setCanNext(false);
        }
    }, [wizardData.filePath]);

    const fetchPreviewData = async () => {
        console.log("Obteniendo vista previa para:", wizardData.filePath); // LOG DEPURACIÓN
        setLoading(true);
        setIsProcessing(true);
        try {
            // Enviamos el módulo para que el backend sepa qué validar
            // const response = await fetch(`${API_BASE}/ImportacionMasiva/preview?filePath=${encodeURIComponent(wizardData.filePath)}&module=${currentModule}`);
            const response = await axios.get(`${API_BASE}/ImportacionMasiva/preview`, {
                params: {
                    filePath: wizardData.filePath,
                    module: currentModule
                }
            });

            if (response.status === 200) {
                const data = response.data;
                console.log("Datos de vista previa recibidos:", data); // LOG DEPURACIÓN

                // VALIDACIÓN FRONTEND ADICIONAL: Verificar campos vacíos
                // Recorremos las filas y si detectamos columnas vacías, marcamos error
                const processedRows = data.rows.map(row => {
                    const emptyCols = [];
                    data.headers.forEach(header => {
                        const val = row.data[header];
                        if (!val || String(val).trim() === "") {
                            emptyCols.push(header);
                        }
                    });

                    if (emptyCols.length > 0) {
                        return {
                            ...row,
                            isValid: false, // Invalidamos la fila
                            errors: [...row.errors, `Campos vacíos: ${emptyCols.join(", ")}`]
                        };
                    }
                    return row;
                });

                setPreviewData({ ...data, rows: processedRows });

                // Habilitamos "Siguiente" solo si hay registros válidos y no todos están excluidos
                const validCount = data.rows.filter(r => r.isValid).length;
                setCanNext(validCount > 0);
            }
        } catch (error) {
            console.error("Error fetching preview:", error);
            const msg = error.response?.data?.message || 'No se pudo leer el archivo';
            triggerAlert(`Error: ${msg}`);
            setCanNext(false);
        } finally {
            setLoading(false);
            setIsProcessing(false);
        }
    };

    const toggleExclude = (index) => {
        const newExcluded = new Set(excludedRows);
        if (newExcluded.has(index)) newExcluded.delete(index);
        else newExcluded.add(index);
        setExcludedRows(newExcluded);

        // Actualizar canNext basado en los registros restantes que son válidos
        const remainingValid = previewData.rows.filter((r, i) => r.isValid && !newExcluded.has(i)).length;
        setCanNext(remainingValid > 0);
    };

    // Hook para detectar cambio de paso (cuando el usuario da clic en Siguiente)
    useEffect(() => {
        if (onStepChange) {
            onStepChange.current = async () => {
                // Lógica de Procesamiento al avanzar del paso 4 al 5
                // Recopilar registros válidos y no excluidos
                const recordsToProcess = previewData.rows
                    .filter((r, i) => r.isValid && !excludedRows.has(i))
                    .map(r => r.data);

                if (recordsToProcess.length === 0) {
                    console.warn("No hay registros válidos para procesar."); // LOG DEPURACIÓN
                    return true; // Nada que procesar
                }

                console.log("Enviando registros al backend (POST /procesar):", recordsToProcess); // LOG DEPURACIÓN

                setIsProcessing(true);
                try {
                    const response = await axios.post(`${API_BASE}/ImportacionMasiva/procesar`, recordsToProcess);

                    if (response.status === 200) {
                        const result = response.data;
                        console.log("Respuesta del backend (Éxito):", result); // LOG DEPURACIÓN

                        // --- DEPURACIÓN DE HASHES ---
                        if (result.detalles) {
                            console.group("Detalle de Generación de Contraseñas");
                            result.detalles.forEach(d => {
                                if (d.status === "OK" && d.debug_pass) {
                                    console.log(`Usuario: ${d.usuario}`, d.debug_pass);
                                }
                            });
                            console.groupEnd();
                        }
                        // -----------------------------

                        // Actualizar el resumen final con los datos reales del backend
                        setWizardData(prev => ({
                            ...prev,
                            summary: {
                                loaded: result.procesados,     // Procesados OK
                                errors: result.errores,        // Errores en BD
                                total: result.total,           // Total enviados
                                duplicates: prev.summary?.duplicates || 0 // Mantener duplicados detectados en frontend
                            }
                        }));
                        return true; // Permitir avance (true = éxito)
                    }
                } catch (error) {
                    console.error("Error processing data:", error);
                    const msg = error.response?.data?.message || 'Error desconocido al procesar';
                    triggerAlert(`Error al procesar: ${msg}`);
                    return false;
                } finally {
                    setIsProcessing(false);
                }
            };
        }
    }, [onStepChange, previewData, excludedRows, setWizardData, setIsProcessing, triggerAlert]);



    if (loading) {
        return (
            <div className="import-modal-placeholder">
                <i className="fas fa-search fa-spin import-main-icon" style={{ color: 'var(--color-primary)' }}></i>
                <h3>Analizando información...</h3>
                <p>Cruzando datos con el sistema para detectar conflictos y validaciones de catálogo.</p>
            </div>
        );
    }

    if (rows.length === 0 && !loading) {
        return (
            <div className="import-modal-placeholder">
                <i className="fas fa-exclamation-triangle import-main-icon" style={{ color: '#f59e0b' }}></i>
                <h3>No se detectaron datos</h3>
                <p>El archivo parece estar vacío o no tiene el formato correcto.</p>
                <button className="btn-action" onClick={fetchPreviewData} style={{ marginTop: '1rem' }}>
                    <i className="fas fa-sync"></i> Reintentar
                </button>
            </div>
        );
    }

    // Calcular estadísticas para el encabezado premium
    const totalRows = rows.length;
    const validRows = rows.filter(r => r.isValid).length;
    const rowsWithErrors = totalRows - validRows;

    return (
        <div className="import-preview-premium">
            {/* Encabezado con Estadísticas Reales */}
            <div className="import-preview-status-bar">
                <div className="status-item">
                    <div className="status-icon total"><i className="fas fa-list-ul"></i></div>
                    <div className="status-text">
                        <span className="count">{totalRows}</span>
                        <span className="label">Total Filas</span>
                    </div>
                </div>
                <div className="status-item">
                    <div className="status-icon success"><i className="fas fa-check-circle"></i></div>
                    <div className="status-text">
                        <span className="count">{validRows}</span>
                        <span className="label">Listos</span>
                    </div>
                </div>
                {rowsWithErrors > 0 && (
                    <div className="status-item">
                        <div className="status-icon danger"><i className="fas fa-times-circle"></i></div>
                        <div className="status-text">
                            <span className="count">{rowsWithErrors}</span>
                            <span className="label">Con Errores</span>
                        </div>
                    </div>
                )}
            </div>

            {/* Contenedor de Tabla con Scroll y Estilo Moderno */}
            <div className="import-table-container">
                <div className="import-table-scroll-area">
                    <table className="import-preview-table">
                        <thead>
                            <tr>
                                <th>Estatus</th>
                                {headers.map((h, idx) => (
                                    <th key={idx}>{h}</th>
                                ))}
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, i) => {
                                const isExcluded = excludedRows.has(i);
                                const hasErrors = !row.isValid;

                                return (
                                    <tr key={i} className={`
                                        ${isExcluded ? 'row-excluded' : ''} 
                                        ${hasErrors ? 'row-has-errors' : 'row-is-valid'}
                                    `}>
                                        <td>
                                            {hasErrors ? (
                                                <button
                                                    className="btn-status-detail error"
                                                    onClick={() => setSelectedErrors(row.errors)}
                                                    title="Ver errores detallados"
                                                >
                                                    <i className="fas fa-exclamation-triangle"></i>
                                                    <span>Error</span>
                                                </button>
                                            ) : (
                                                <div className="badge-status success" title="Registro válido">
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            )}
                                        </td>

                                        {headers.map((h, j) => {
                                            let displayValue = row.data[h];

                                            // Limpiar fecha de nacimiento (quitar hora si existe)
                                            if (h === 'FechaNacimiento' && displayValue) {
                                                displayValue = displayValue.split(' ')[0].split('T')[0];
                                            }

                                            return (
                                                <td key={j} className={hasErrors && row.errors.some(e => e.includes(`'${h}'`)) ? 'cell-error-highlight' : ''}>
                                                    {displayValue || <span className="cell-empty">--</span>}
                                                </td>
                                            );
                                        })}

                                        <td>
                                            <button
                                                className={`rk-iconbtn ${isExcluded ? 'rk-iconbtn--edit' : 'rk-iconbtn--del'}`}
                                                onClick={() => toggleExclude(i)}
                                                title={isExcluded ? "Incluir registro" : "Ignorar registro"}
                                            >
                                                {isExcluded ? <i className="fas fa-undo-alt"></i> : <img src={sigmaDelete} alt="" className="rk-ico" />}
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Disclaimer y Leyenda */}
            <div className="import-preview-legend">
                <div className="legend-item">
                    <span className="dot error"></span>
                    <span>Filas en rojo contienen errores y serán omitidas automáticamente.</span>
                </div>
                <div className="legend-item">
                    <i className="fas fa-mouse-pointer"></i>
                    <span>Haz clic en el botón de basura para ignorar filas manualmente.</span>
                </div>
            </div>

            {/* Mini Modal de Errores Detallados - Rediseñado */}
            {selectedErrors && (
                <div className="import-error-overlay" onClick={() => setSelectedErrors(null)}>
                    <div className="import-error-card" onClick={e => e.stopPropagation()}>
                        <div className="error-card-header">
                            <div className="header-icon"><i className="fas fa-exclamation-circle"></i></div>
                            <div className="header-content">
                                <h4>Errores del Registro</h4>
                                <p>Corrige estos puntos para poder importar esta fila.</p>
                            </div>
                            <button className="close-corner" onClick={() => setSelectedErrors(null)}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <div className="error-card-body">
                            <ul className="error-check-list">
                                {selectedErrors.map((err, idx) => (
                                    <li key={idx}>
                                        <i className="fas fa-caret-right"></i>
                                        {err}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="error-card-footer">
                            <button className="btn-action sm" onClick={() => setSelectedErrors(null)}>Entendido</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// Paso 5: Resultado / Confirmación
const StepResult = ({ setCanNext, wizardData }) => {
    useEffect(() => {
        setCanNext(true);
    }, [setCanNext]);

    const { summary } = wizardData;
    const stats = summary || { loaded: 0, errors: 0, duplicates: 0, total: 0 };

    return (
        <div className="import-modal-placeholder">

            <h3 style={{ fontSize: '1.8rem', marginTop: '1rem' }}>¡Proceso Completado!</h3>
            <p style={{ maxWidth: '500px', margin: '0.75rem auto 2rem' }}>
                La validación y registro ha finalizado
            </p>

            <div className="import-final-summary-list">
                <div className="summary-row loaded">
                    <div className="summary-row-info">
                        <i className="fas fa-user-check"></i>
                        <span>Registros listos para cargar</span>
                    </div>
                    <div className="summary-row-value">{stats.loaded}</div>
                </div>

                <div className="summary-row duplicates">
                    <div className="summary-row-info">
                        <i className="fas fa-copy"></i>
                        <span>Registros duplicados (omitidos)</span>
                    </div>
                    <div className="summary-row-value">{stats.duplicates}</div>
                </div>

                <div className="summary-row errors">
                    <div className="summary-row-info">
                        <i className="fas fa-exclamation-circle"></i>
                        <span>Registros con errores de formato</span>
                    </div>
                    <div className="summary-row-value">{stats.errors}</div>
                </div>

                <div className="summary-row-footer">
                    <span>Total analizado en el archivo:</span>
                    <strong>{stats.total} registros</strong>
                </div>
            </div>
        </div>
    );
};
/**
 * ImportacionMasivaManager - Panel principal para gestionar las importaciones masivas.
 */
export default function ImportacionMasivaManager() {
    const [modalOpen, setModalOpen] = useState(false);
    const [currentModule, setCurrentModule] = useState(null);
    const [alertConfig, setAlertConfig] = useState({ open: false, title: 'Información', message: '', variant: 'info' });
    const [searchTerm, setSearchTerm] = useState("");
    const [activeFilter, setActiveFilter] = useState("todos");

    const triggerAlert = (message, variant = 'error', title = 'Error') => {
        setModalOpen(false);
        setAlertConfig({ open: true, message, variant, title });
    };

    // Configuración estándar de 5 pasos para todos los módulos
    const standardWizardSteps = [
        { title: "Preparación", description: "Instrucciones del proceso", component: StepInstructions },
        { title: "Plantilla", description: "Descarga de formato oficial", component: StepDownload },
        { title: "Carga de Datos", description: "Subida de archivo Excel", component: StepUpload },
        { title: "Vista Previa", description: "Validación de información detectada", component: StepPreview },
        { title: "Finalización", description: "Resultado de la importación", component: StepResult }
    ];

    const wizardConfigs = {
        empleados: standardWizardSteps,
        puestos: standardWizardSteps,
        cursos: standardWizardSteps,
        historico: standardWizardSteps
    };

    const modules = [
        {
            category: "Recursos Humanos",
            items: [
                { id: "empleados", title: "Importación de Empleados", description: "Carga masiva de colaboradores y puestos.", icon: "fas fa-users-cog", tag: "Principal" }
            ]
        }
    ];

    const handleOpenWizard = (modId) => {
        setCurrentModule(modId);
        setModalOpen(true);
    };

    // Filtrado de módulos
    const filteredModules = modules.map(section => ({
        ...section,
        items: section.items.filter(item => {
            const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.description.toLowerCase().includes(searchTerm.toLowerCase());
            const matchesCategory = activeFilter === "todos" || section.category.toLowerCase().includes(activeFilter.toLowerCase());
            return matchesSearch && matchesCategory;
        })
    })).filter(section => section.items.length > 0);

    return (
        <div className="importacion-masiva-container">


            {/* UI de Toggle y Búsqueda - Estilo "Mis Cursos" */}
            <div style={{ marginBottom: '2rem', filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.05))' }}>
                <div style={{
                    display: 'flex',
                    width: '100%',
                    backgroundColor: '#f1f5f9',
                    borderRadius: '12px 12px 0 0',
                    overflow: 'hidden',
                    padding: '0.4rem',
                    gap: '0.5rem',
                    border: '1px solid #e2e8f0',
                    borderBottom: 'none'
                }}>
                    {['todos', 'recursos'].map((option) => (
                        <div
                            key={option}
                            onClick={() => setActiveFilter(option)}
                            style={{
                                flex: 1,
                                textAlign: 'center',
                                padding: '0.4rem 0',
                                fontSize: '0.9rem',
                                fontWeight: activeFilter === option ? 700 : 500,
                                color: activeFilter === option ? 'var(--color-primary-dark)' : '#64748b',
                                backgroundColor: activeFilter === option ? '#ffffff' : 'transparent',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                userSelect: 'none',
                                textTransform: 'capitalize',
                                boxShadow: activeFilter === option ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'
                            }}
                        >
                            {option === 'todos' ? 'Todo' : 'RH'}
                        </div>
                    ))}
                </div>

                <div style={{
                    background: '#ffffff',
                    border: '1px solid #e2e8f0',
                    borderTop: 'none',
                    borderRadius: '0 0 12px 12px',
                    padding: '0.8rem 1rem',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        background: '#fff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '999px',
                        padding: '0.4rem 1rem'
                    }}>
                        <i className="fas fa-search" style={{ color: 'var(--color-primary-dark)', marginRight: '0.6rem' }}></i>
                        <input
                            type="text"
                            placeholder="Buscar catálogo para importar..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ border: 'none', outline: 'none', background: 'transparent', width: '100%', fontSize: '0.9rem' }}
                        />
                    </div>
                </div>
            </div>

            <div className="importacion-groups-container">
                {filteredModules.length > 0 ? (
                    <div className="courses-grid fixed-cards">
                        {filteredModules.flatMap(section =>
                            section.items.map((item) => (
                                <article key={item.id} className="course-card fixed-card">
                                    <div className={`course-thumb ${section.category.toLowerCase().includes('capacitacion') ? 'lms-premium' : 'rh-premium'}`}>
                                        <i className={item.icon}></i>
                                    </div>
                                    <div className="course-body">
                                        <h3 className="course-title">{item.title}</h3>

                                        <div style={{ marginTop: "0.8rem" }}>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '0.6rem' }}>
                                                {/* Habilidad - Barra completa */}
                                                <div style={{
                                                    fontSize: '0.8rem',
                                                    backgroundColor: '#e0f2fe',
                                                    color: '#0369a1',
                                                    padding: '4px 12px',
                                                    borderRadius: '9999px',
                                                    fontWeight: 600,
                                                    width: '100%',
                                                    display: 'block',
                                                    textAlign: 'left'
                                                }}>
                                                    {item.tag || "General"}
                                                </div>

                                                {/* Nivel - Barra completa */}
                                                <div style={{
                                                    fontSize: '0.8rem',
                                                    backgroundColor: '#f1f5f9',
                                                    color: '#475569',
                                                    padding: '4px 12px',
                                                    borderRadius: '9999px',
                                                    fontWeight: 600,
                                                    width: '100%',
                                                    display: 'block',
                                                    textAlign: 'left'
                                                }}>
                                                    {section.category.split('(')[0].trim()}
                                                </div>
                                            </div>
                                        </div>

                                        <p style={{ fontSize: '0.85rem', color: '#64748b', lineHeight: '1.4', margin: '0.5rem 0 1rem', display: '-webkit-box', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                            {item.description}
                                        </p>

                                        <div className="course-actions">
                                            <button
                                                type="button"
                                                className="btn-action"
                                                onClick={() => handleOpenWizard(item.id)}
                                                style={{
                                                    width: '100%',
                                                    padding: '0.5rem 1rem',
                                                    cursor: 'pointer',
                                                    transition: '0.2s',
                                                    fontFamily: "'Outfit', sans-serif"
                                                }}
                                            >
                                                Importar Datos
                                            </button>
                                        </div>
                                    </div>
                                </article>
                            ))
                        )}
                    </div>
                ) : (
                    <div className="import-empty-search">
                        <i className="fas fa-search-minus"></i>
                        <h3>No encontramos lo que buscas</h3>
                        <p>Intenta con otros términos o cambia la categoría de filtro.</p>
                        <button className="btn-action sm" onClick={() => { setSearchTerm(""); setActiveFilter("todos"); }}>
                            Limpiar filtros
                        </button>
                    </div>
                )}
            </div>

            <ImportacionMasivaModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                title="Proceso de Importación"
                description="Siga los pasos para completar la carga"
                steps={wizardConfigs[currentModule] || []}
                currentModule={currentModule}
                onFinish={() => {
                    setModalOpen(false);
                    setAlertConfig({
                        open: true,
                        title: "Carga Completada",
                        message: "¡El proceso ha finalizado con éxito! Los datos han sido integrados correctamente al sistema.",
                        variant: "success"
                    });
                }}
                triggerAlert={triggerAlert}
            />

            <AlertDialog
                open={alertConfig.open}
                onClose={() => setAlertConfig({ ...alertConfig, open: false })}
                title={alertConfig.title}
                message={alertConfig.message}
                variant={alertConfig.variant}
                buttonText="Entendido"
            />
        </div>
    );
}
